import React, { useEffect, useState } from "react";
import SectionHeader from "./SectionHeader";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import ReCAPTCHA from "react-google-recaptcha";
import * as Icon from "react-bootstrap-icons";
import { Alert, Spinner } from "react-bootstrap";
import axios from "axios";

export const MessageForm = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isSubjectsLoading, setIsSubjectsLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState(null);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [captcha, setCaptcha] = useState(null);
  const [formMessage, setFormMessage] = useState("");
  const [formMessageVariant, setFormMessageVariant] = useState("danger");
  const [captchaShow, setCaptchaShow] = useState(true);
  const [page, setPage] = useState(1);
  const [fileRequired, setFileRequired] = useState(false);
  const btn = React.useRef();

  const handleUpload = () => {
    btn.current.click();
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/messages/subjects/`)
      .then((res) => {
        setSubjects(res.data);
      })
      .then(() => {
        setIsSubjectsLoading(false);
      });
  }, []);

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const _handleCaptchaReload = () => {
    setCaptchaShow(false);
    setCaptcha(null);
    setTimeout(() => {
      setCaptchaShow(true);
    }, 100);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    setFormMessage("");
    var error = 0;
    if (file === null || file === "") {
      if (formMessage === "" && fileRequired === true && file === null) {
        setFormMessage(getContent(content, "File is required!", lang));
        setFormMessageVariant("danger");
        error = 1;
      }
    }
    if (captcha === null || captcha === "") {
      if (formMessage === "") {
        setFormMessage(getContent(content, "Captcha is required!", lang));
        setFormMessageVariant("danger");
        error = 1;
      }
    } else {
      formData.append("captcha", captcha);
    }
    if (message === "") {
      if (formMessage === "") {
        setFormMessage(getContent(content, "Message is required!", lang));
        setFormMessageVariant("danger");
        error = 1;
      }
    } else {
      formData.append("message", message);
    }
    if (subject === null || subject === "") {
      if (formMessage === "") {
        setFormMessage(getContent(content, "Subject is required!", lang));
        setFormMessageVariant("danger");
        error = 1;
      }
    } else {
      formData.append("subject", subject);
    }
    if (email === "" || !isValidEmail(email)) {
      if (formMessage === "") {
        setFormMessage(getContent(content, "Email is required!", lang));
        setFormMessageVariant("danger");
        error = 1;
      }
    } else {
      formData.append("email", email);
    }
    if (fullname === "") {
      if (formMessage === "") {
        setFormMessage(getContent(content, "Fullname is required!", lang));
        setFormMessageVariant("danger");
        error = 1;
      }
    } else {
      formData.append("fullname", fullname);
    }
    if (error === 0) {
      setButtonLoading(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/api/v1/messages/create/`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((data) => {
          if (data.status === 200) {
            setPage(2);
          } else {
            setFormMessage(data.response.data.detail[lang]);
            setFormMessageVariant("danger");
          }
        })
        .catch((data) => {
          setFormMessage(data.response.data.detail[lang]);
          setFormMessageVariant("danger");
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
  };

  const handleSubmitOtp = () => {
    const formData = new FormData();
    setFormMessage("");
    if (file === null || file === "") {
      if (formMessage === "" && fileRequired === true) {
        setFormMessage(getContent(content, "File is required!", lang));
        setFormMessageVariant("danger");
      }
    } else {
      formData.append("file", file);
    }
    if (otp === "") {
      if (formMessage === "") {
        setFormMessage(getContent(content, "OTP is required!", lang));
        setFormMessageVariant("danger");
      }
    } else {
      formData.append("otp", otp);
    }
    if (email === "" || !isValidEmail(email)) {
      if (formMessage === "") {
        setFormMessage(getContent(content, "Email is required!", lang));
        setFormMessageVariant("danger");
      }
    } else {
      formData.append("email", email);
    }
    setButtonLoading(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/v1/messages/check-otp/`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((data) => {
        if (data.status === 200) {
          setFormMessage(
            getContent(content, "Your message was sent successfully!", lang)
          );
          setFormMessageVariant("success");
          setPage(1);
        } else {
          setFormMessage(data.response.data.detail[lang]);
          setFormMessageVariant("danger");
        }
      })
      .catch((data) => {
        setFormMessage(data.response.data.detail[lang]);
        setFormMessageVariant("danger");
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <div className="message-form">
      <div className="container">
        <div className="row"></div>
        <div className="row">
          <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
            <SectionHeader
              title={getContent(content, "Contact with us", lang)}
              content={getContent(content, "Contact with us content", lang)}
              width="100"
            />
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
            {page !== 2 ? (
              <div className="row">
                <div className="col-12 error-wrapper">
                  {formMessage !== "" ? (
                    <Alert variant={formMessageVariant} dismissible>
                      {formMessage}
                    </Alert>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div className="mb-4 floating-label">
                    <input
                      type="text"
                      name="fullname"
                      className="form-control"
                      placeholder=" "
                      required
                      onChange={(e) => {
                        setFullname(e.target.value);
                      }}
                    />
                    <label htmlFor="text">
                      {getContent(content, "Fullname", lang)} *
                    </label>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div className="mb-4 floating-label">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder=" "
                      required
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    <label htmlFor="text">
                      {getContent(content, "Email", lang)} *
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-4 floating-label">
                    <select
                      name="subject"
                      className="form-control"
                      required
                      onChange={(e) => {
                        setSubject(e.target.value);
                        if (e.target.value !== null && subjects.length > 0) {
                          for (var i = 0; i < subjects.length; i++) {
                            if (subjects[i].id.toString() === e.target.value) {
                              if (subjects[i].file_required === true) {
                                setFileRequired(true);
                              } else setFileRequired(false);
                            }
                          }
                        } else setFileRequired(false);
                      }}
                    >
                      <option value="">
                        {getContent(content, "No option", lang)}
                      </option>
                      {isSubjectsLoading === true ? (
                        <option value="loading">Loading...</option>
                      ) : (
                        subjects.map((subject) => (
                          <option value={subject.id} key={subject.id}>
                            {lang === "en"
                              ? subject.name_en
                              : lang === "ru"
                              ? subject.name_ru
                              : subject.name_tm}
                          </option>
                        ))
                      )}
                    </select>
                    <label htmlFor="text">
                      {getContent(content, "Subject", lang)} *
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-3 floating-label">
                    <textarea
                      name="message"
                      rows="3"
                      className="form-control"
                      placeholder=" "
                      onChange={(e) => {
                        setMessage(e.target.value);
                      }}
                    ></textarea>
                    <label htmlFor="text">
                      {getContent(content, "Message", lang)} *
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <label
                    htmlFor="text"
                    className="mb-2"
                    style={{
                      fontWeight: fileRequired === true ? "600" : "400",
                    }}
                  >
                    {getContent(content, "Additional information", lang)}{" "}
                    {fileRequired === true ? "*" : ""}
                  </label>
                  <div className="mb-3">
                    <button
                      className="clear-btn upload-btn"
                      onClick={() => handleUpload()}
                    >
                      <Icon.Upload /> &nbsp;{" "}
                      {getContent(content, "Upload file", lang)}
                    </button>{" "}
                    &nbsp;
                    {file !== null ? file.name : ""}
                    <input
                      type="file"
                      name="file"
                      className="form-control d-none"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                      ref={(node) => (btn.current = node)}
                    />
                    <p className="help-text">
                      {getContent(content, "file help text", lang)}
                    </p>
                  </div>
                </div>
                <div className="col-6 position-relative">
                  {captchaShow === true ? (
                    <ReCAPTCHA
                      sitekey="6Lc5naImAAAAAFd5yWkdd56mSJpiAghI1wyTTgCh"
                      onChange={(value) => setCaptcha(value)}
                      style={{
                        marginRight: "10px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {captcha !== null ? (
                    <span
                      className="subscribe-clear"
                      style={{
                        left: "330px",
                        right: "auto",
                        lineHeight: "19px",
                        top: "15px",
                      }}
                      onClick={() => _handleCaptchaReload()}
                    >
                      ×
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 d-flex justify-content-end align-items-center">
                  {buttonLoading === true ? (
                    <Spinner />
                  ) : (
                    <button
                      className="black-btn clear-btn px-5 message-form-send"
                      onClick={() => handleSubmit()}
                    >
                      {getContent(content, "Send", lang)} &nbsp; <Icon.Send />
                    </button>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            {page === 2 ? (
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-auto error-wrapper">
                  {formMessage !== "" ? (
                    <Alert variant={formMessageVariant} dismissible>
                      {formMessage}
                    </Alert>
                  ) : (
                    ""
                  )}
                </div>
                <div className="clearfix"></div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-auto">
                  <p className="text-center">
                    {getContent(
                      content,
                      "We've sent you an email code. \nTo complete the sending email process, please enter the 6 digit code below",
                      lang
                    )}
                  </p>
                  <div className="mb-4 floating-label">
                    <input
                      type="number"
                      maxLength={6}
                      minLength={6}
                      name="otp"
                      className="form-control"
                      placeholder=" "
                      required
                      onChange={(e) => {
                        setOtp(e.target.value);
                      }}
                    />
                    <label htmlFor="text">
                      {getContent(content, "Code", lang)} *
                    </label>
                  </div>
                </div>
                <div className="clearfix"></div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-auto d-flex justify-content-center">
                  {buttonLoading === true ? (
                    <Spinner />
                  ) : (
                    <button
                      className="black-btn clear-btn px-5"
                      onClick={() => handleSubmitOtp()}
                    >
                      {getContent(content, "Send", lang)} &nbsp; <Icon.Send />
                    </button>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
